import { render, staticRenderFns } from "./TaxMapping.vue?vue&type=template&id=41a9028a&scoped=true&"
import script from "./TaxMapping.vue?vue&type=script&lang=js&"
export * from "./TaxMapping.vue?vue&type=script&lang=js&"
import style0 from "./TaxMapping.vue?vue&type=style&index=0&id=41a9028a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a9028a",
  null
  
)

export default component.exports